import React, { useRef, useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import {
  Wrapper,
  Logged,
  UserName,
  InitSession,
  ButtonPackage,
  Session,
  Name,
  Content,
  CounterAvailableFeatureResponsive,
  BreadCrumbDesktop,
  IconExpand,
  LoggedMain,
  Option,
  IconExit,
  LoaderWrapper,
  InitSessionWrapper
} from './styled';
import { UbicationSite, Logo, NavBar } from '@app/src/common/header';
import { isClientEnv } from '@app/src/utils/validations';
import { COLORS } from '@app/src/ui';
import { HeadBand } from '@app/src/common/headBand';
import { FlashMessageError } from '@app/src/common/flashMessageError';
import { Icon } from '@app/src/common/Icon';
import { fetchLogout, setUserName } from '@app/src/common/session';

interface Props {
  itemActive?: string;
  ubicationSite?: boolean;
  positionOf?: Array<number>;
  className?: string;
  breadCrumb?: boolean;
  titleBreadCrumb?: string;
  announcementAvailable?: boolean;
  children?: any;
  search?: boolean;
}

const isClient = isClientEnv();
const CONFIRM_VIEW = '/confirmacion';
const PENDING_VIEW = '/pendiente';
const PACKAGE_VIEW = '/compra-tu-paquete-de-avisos-impreso';

export const Header: React.FC<Props> = ({
  itemActive,
  ubicationSite,
  className,
  positionOf,
  breadCrumb,
  titleBreadCrumb,
  announcementAvailable,
  children,
}) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const refHeader = useRef(null);
  const location = useLocation();
  const navRef = useRef(null);

  const userName = useSelector(state => state.session.user.name);
  const userStorage = isClient && JSON.parse(localStorage.getItem('user'));
  const [isOpenLoggedOptions, setIsOpenLoggedOptions] = useState(false);
  const isLoadingLogout = useSelector(state => state.session.logout.isFetching);
  const isLoadingLogin = useSelector(state => state.session.login.isFetching);
  const isLogout = useSelector(state => state.session.logout.isLogout);

  useEffect(() => {
    if (isClient) {
      window.addEventListener('scroll', handleHeaderFixed);
      window.addEventListener('resize', handleHeaderFixed);
      handleHeaderFixed();
      return () => {
        window.removeEventListener('load', handleHeaderFixed);
        window.removeEventListener('resize', handleHeaderFixed);
        window.addEventListener('scroll', handleHeaderFixed);
        handleHeaderFixed();
      };
    }
  });

  useEffect(() => {
    if (isLogout) {
      dispatch(setUserName(''));
    }
  }, [isLogout]);

  const handleHeaderFixed = () => {
    const header = refHeader && refHeader.current;

    if (window.pageYOffset > 0) {
      header && header.classList && header.classList.add('u-fixed-header');
    } else {
      header && header.classList && header.classList.remove('u-fixed-header');
    }
  };

  const handleClickSession = (e) => {
    e.preventDefault();
    history.push('/inicia-tu-sesion');
  };

  const handleClickPackage = () => {
    const url = location.pathname.split('-')[0];
    if (isClient) {
      if (url === CONFIRM_VIEW || url === PENDING_VIEW) {
        (window as any).location.href = PACKAGE_VIEW;
      } else {
        history.push(PACKAGE_VIEW);
      }
    }
  };

  const pushDatalayerPackage = () => {
    if (isClient && (window as any).dataLayer) {
      (window as any).dataLayer.push({
        'event': 'EV Paquetes Avisos',
        'category': 'Paquetes Avisos',
        'action': 'Paquete Avisos_P1',
        'label': userStorage && userStorage.user || userStorage && userStorage.data && userStorage.data.id,
        'value': 1
      })
    }
  };

  const handleClickLogged = () => {
    setIsOpenLoggedOptions(!isOpenLoggedOptions);
  };

  const handleClickLoggedOptions = (e) => {
    const element = e.target;
    const link = element.dataset.link;
    if (link === '/') {
      dispatch(fetchLogout({ jwt: userStorage.jwt }, userStorage.jwt));
    }
    if (link === '/mi-cuenta') {
      (window as any).location.href = link;
    }
  };

  return (
    <React.Fragment>
      <Wrapper
        id="header"
        className={className}
        ref={refHeader}>
        <Content>
          <Logo />
          {ubicationSite && <UbicationSite itemActive={itemActive} />}
          {
            <NavBar
              navRef={navRef}
            />
          }
          <Session onClick={pushDatalayerPackage}>
            {
              userName ?
                <Name>
                  <Logged onClick={handleClickLogged}>
                    Hola, <UserName>{userName}</UserName>
                    <IconExpand isDisplay={isOpenLoggedOptions}><Icon data-name="icon-expand-more" fill={COLORS.BLACK} width="12" height="12" /></IconExpand>
                  </Logged>
                  <LoggedMain isDisplay={isOpenLoggedOptions} onClick={handleClickLoggedOptions}>
                    <Option data-link="/mi-cuenta">Mi cuenta</Option>
                    <Option data-link="/">
                      Salir
                      {
                        isLoadingLogout ?
                          <LoaderWrapper>
                            <Icon data-name='icon-circle' fill='#ccc' width={'17'} height={'17'} />
                          </LoaderWrapper>
                          :
                          <IconExit>
                            <Icon data-name="icon-logout" fill={COLORS.GRAY_TEXT} width={'20'} height={'20'} />
                          </IconExit>
                      }
                    </Option>
                  </LoggedMain>
                </Name>
                :
                <InitSessionWrapper>
                  {
                    isLoadingLogin ?
                    <LoaderWrapper>
                      <Icon data-name='icon-circle' fill='#ccc' width={'17'} height={'17'} />
                    </LoaderWrapper>
                    :
                    <InitSession href="#" onClick={handleClickSession}>Ingresar</InitSession>
                  }
                </InitSessionWrapper>
            }
            {
              !children ?
                <ButtonPackage
                  color="#fff"
                  background="#000"
                  handleClick={handleClickPackage}
                >ver paquetes</ButtonPackage>
                : children
            }
          </Session>
        </Content>
        <FlashMessageError />
        {breadCrumb && <BreadCrumbDesktop positionOf={positionOf} title={titleBreadCrumb} />}
      </Wrapper>
      <HeadBand />
      {announcementAvailable && <CounterAvailableFeatureResponsive />}
    </React.Fragment>
  );
};

Header.displayName = 'Header';
